import axios from 'axios';
const DataService = {};

DataService.getCountries = async function () {
    const { data } = await axios.get(
        `${axios.defaults.baseURL}/api/v1/data/countries`
    );
    return data;
};

DataService.getStates = async function (countryCode) {
    const { data } = await axios.get(
        `${axios.defaults.baseURL}/api/v1/data/states/${countryCode}`
    );
    return data;
};

DataService.getPriceByCountry = async function (countryCode, productNumber) {
    const { data } = await axios.get(
        `${axios.defaults.baseURL}/api/v1/data/price/${countryCode}/${productNumber}`
    );
    return data;
};

DataService.getAllPrices = async function (countryCode) {
    const { data } = await axios.get(
        `${axios.defaults.baseURL}/api/v1/data/list-prices/${countryCode}`
    );
    return data;
};

DataService.getModulesEnabled = async function () {
    const { data } = await axios.get(
        `${axios.defaults.baseURL}/api/v1/data/modules/enabled`
    );
    return data;
};

export default DataService;
